import { useI18n } from "../i18n/LanguageContext";

// A restrained editorial marquee — boutique-consultancy "cities we serve"
const CITIES = [
  "Antwerpen",
  "Amsterdam",
  "Brussel",
  "Luxembourg",
  "Rotterdam",
  "Gent",
  "Eindhoven",
  "Den Haag",
  "Mechelen",
  "Utrecht",
  "Esch-sur-Alzette",
  "Leuven",
];

export default function Marquee() {
  const { t } = useI18n();
  const loop = [...CITIES, ...CITIES];
  return (
    <section className="border-y border-border overflow-hidden bg-background" data-testid="cities-marquee">
      <div className="container-wide py-6 flex items-center gap-10">
        <p className="hidden md:block text-xs uppercase tracking-[0.22em] font-bold text-muted-foreground whitespace-nowrap">
          — {t.common.benelux}
        </p>
        <div className="relative flex-1 overflow-hidden">
          <div className="flex gap-12 whitespace-nowrap will-change-transform animate-[marquee_45s_linear_infinite]">
            {loop.map((c, i) => (
              <span key={i} className="flex items-center gap-12">
                <span className="font-display text-2xl md:text-3xl text-foreground/85 tracking-tight">{c}</span>
                <span className="text-accent">✦</span>
              </span>
            ))}
          </div>
        </div>
      </div>
      <style>{`
        @keyframes marquee {
          from { transform: translateX(0); }
          to { transform: translateX(-50%); }
        }
      `}</style>
    </section>
  );
}
